module.exports = __webpack_public_path__ + "img/solution_7.9794d9d8.png";